"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TickIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var withSVGIcon_1 = require("./withSVGIcon");
var Icon = function (_a) {
    var _b = _a.strokeWidth, strokeWidth = _b === void 0 ? 1 : _b;
    return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: jsx_runtime_1.jsx("path", { d: "M15.6656 22.6486L15.1352 23.1791L15.1385 23.1823L11.9566 26.3642L2.41066 16.8183L5.59264 13.6363L11.423 19.4667L11.9533 19.997L12.4837 19.4667L26.3897 5.56066L29.5716 8.74264L15.6656 22.6486Z", fill: "#FFFD63", stroke: "black", strokeWidth: strokeWidth }, void 0) }, void 0));
};
exports.TickIcon = withSVGIcon_1.withSVGIcon(Icon, { viewBox: '0 0 32 32' });
//# sourceMappingURL=TickIcon.js.map